export default __webpack_public_path__ + "static/azure-data-services-7a53f852d688a6e3d6edf8f372148e7e.svg";